export default __webpack_public_path__ + "static/media/2020-interior-1.a3e1ec29.jpeg";